const value = {
    projects: 'Projects',
    systems: 'Systems',
    settings: 'Settings',
    logout: 'Logout',
    learning: 'Learning',
    analytics: 'Analytics',
    leaderBoards: 'Leaderboards',
  };

export default value;
